import { createRouter, createWebHistory } from "vue-router"
import VueConfig from "../../../vue.config"

const basePath = VueConfig.publicPath
const router = createRouter({
	base: basePath,
	history: createWebHistory(basePath),
	routes: [
		{
			name: "home",
			path: "/:mapKey?",
			component: () => import("@/components/Core"),
		},

		// redirect invalid paths to home
		{
			path: "/:pathMatch(.*)*",
			redirect: { name: "home" },
		},
	],
})

// TODO: use the navigation guard for queries etc
/*
router.beforeEach((to, from, next) => {
	next()
})
*/

export default router
